define('view/controller/review/ReviewDeleteDialogView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Review delete dialog view
     *
     * @class ReviewDeleteDialogView
     */
    return LayoutView.extend({

        template: '#reviews_delete_dialog',
        ui: {
            cancelBtn: '#sb_review_delete_cancel',
            confirmBtn: '#sb_review_delete_confirm'
        },
        events: {
            'click @ui.confirmBtn': 'performConfirm'
        },

        performConfirm: function () {
            this.triggerMethod('confirm', {
                model: this.model,
                region: this._parent
            });
        }

    });

});
